module.exports = "/_next/static/images/af236cce5b4319f935fd6cbad4ba91bb-phone-desktop.png.webp";